
export enum ContactType {
    Email = 'Email',
    Phone = 'Phone'
}

export interface Contact {
    id: number,
    description: string,
    value: string,
    type: ContactType
}